'use client';

import PhosphorIcon from '@/components/base/icon/phosphor-icon';
import { Redirect, getRedirectPath } from '@/utils/redirects';
import { Phone } from '@phosphor-icons/react/dist/ssr';
import { useLocale, useTranslations } from 'next-intl';

export const SimplifyFooter = () => {
  const t = useTranslations('common');
  const tn = useTranslations('navigation');
  const locale = useLocale();
  const links = [
    {
      label: tn('regulations'),
      href: getRedirectPath(Redirect.REGULATIONS, locale),
    },
    {
      label: tn('privacy_policy'),
      href: getRedirectPath(Redirect.PRIVACY, locale),
    },
    {
      label: tn('returns'),
      href: getRedirectPath(Redirect.RETURNS, locale),
    },
  ];

  return (
    <div className="mt-xl s:mt-xxl border-t-1 border-t-decorative border-b-6 border-b-brand bg-alt">
      <div className="container flex min-h-[150px] flex-col items-center justify-center gap-m py-inner">
        <div className="flex w-full m:flex-row flex-col items-center justify-between gap-m">
          <div className="flex justify-center gap-m">
            <a
              href={`tel:${t('company.phone_url')}`}
              className="flex items-center gap-xxs border-decorative border-b-1"
            >
              <PhosphorIcon Icon={Phone} className="icon-s" />
              {t('company.phone')}
            </a>
          </div>
          <div className="flex flex-wrap justify-center gap-m">
            {links.map(({ label, href }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                aria-label={label}
                className="whitespace-nowrap border-decorative border-b-1 text-muted"
                rel="noreferrer"
              >
                {label}
              </a>
            ))}
          </div>
        </div>
        <div className="text-center text-small">
          2006–{new Date().getFullYear()} {tn('copyrights.copyright')} ©&nbsp;
          {t('company.name')} {tn('copyrights.rights_reserved')}
        </div>
      </div>
    </div>
  );
};
